module.exports = __webpack_public_path__ + "media/jackpot_winner.74748f8c.mp3";